module.exports = __webpack_public_path__ + "media/assets/images/logo-legado-aguas-99f1ded578852ccb7070672c4b9a440a.png";